import * as React from 'react';

export const CheckIcon = () => {
    return (
        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4.33721L4.14516 8L10 1" stroke="var(--primary-text-color)" stroke-width="2.4"/>
        </svg>
    );
};
